import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

import { FocusedSkuAnalysisPage } from '@/components/FocusedSkus/FocusedSkuAnalysisPage'
import {
  analysisSearchSchema,
  withoutAnalysisDefaults,
  type AnalysisSearch,
} from '@/components/FocusedSkus/analysisSearch'

/** Wiring only. The schema lives beside the page in `analysisSearch.ts`. */
export const Route = createFileRoute('/_app/focused-data/analyzer/')({
  validateSearch: analysisSearchSchema,
  component: AnalyzerRoute,
})

function AnalyzerRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })
  const onSearchChange = useCallback(
    (next: Partial<AnalysisSearch>) =>
      void navigate({
        search: (current) => withoutAnalysisDefaults({ ...current, ...next }),
        replace: true,
      }),
    [navigate],
  )
  return <FocusedSkuAnalysisPage search={search} onSearchChange={onSearchChange} />
}
